import { queryParameters, fetchJson } from 'util/fetch';
import {
  GET,
  POST
} from './types';

export default (apiUrl, httpClient = fetchJson) => {
  const convertRESTRequestToHTTP = (httpMethod, apiPath, params) => {
    let url = '';
    const options = {};
    switch (httpMethod) {
      case GET: {
        url = `${apiUrl}${apiPath}?${queryParameters(params)}`;
        break;
      }
      case POST:
        url = `${apiUrl}${apiPath}`;
        options.method = 'POST';
        if (params.data instanceof FormData) {
          options.body = params.data;
        }
        else {
          options.body = JSON.stringify(params.data);
        }
        break;
      default:
        throw new Error(`Unsupported fetch action type ${httpMethod}`);
    }
    return { url, options };
  };

  return (httpType, apiPath, params) => {
    const { url, options } = convertRESTRequestToHTTP(httpType, apiPath, params);
    return httpClient(url, options)
      .then(response => response.json);
  };
};



// WEBPACK FOOTER //
// ./src/api/customClient.js